/// <summary>
/// Gets the dali fade times for DaliSettings 4 DIM.
/// </summary>
/// <value>
/// The switch on fade times.
/// </value>
export const daliFadeTimes = [
    { key: 0, value: "0" },
    { key: 1, value: "0.675" },
    { key: 2, value: "0.7" },
    { key: 3, value: "1.0" },
    { key: 4, value: "1.4" },
    { key: 5, value: "2.0" },
    { key: 6, value: "2.8" },
    { key: 7, value: "4.0" },
    { key: 8, value: "5.7" },
    { key: 9, value: "8.0" },
    { key: 10, value: "11.3" },
    { key: 11, value: "16" },
    { key: 12, value: "22.6" },
    { key: 13, value: "32" },
    { key: 14, value: "45.3" },
    { key: 15, value: "64" },
    { key: 16, value: "90.5" },
];

/// <summary>
/// Gets the dali times multiplier for DaliSettings 4 DIM.
/// </summary>
/// <value>
/// The switch on fade times multiplier.
/// </value>
export const daliFadeTimeBase = [
    { key: 1, value: "1" },
    { key: 2, value: "2" },
    { key: 3, value: "3" },
    { key: 4, value: "4" },
    { key: 5, value: "5" },
    { key: 6, value: "6" },
    { key: 7, value: "7" },
    { key: 8, value: "8" },
    { key: 9, value: "9" },
    { key: 10, value: "10" },
    { key: 11, value: "11" },
    { key: 12, value: "12" },
    { key: 13, value: "13" },
    { key: 14, value: "14" },
    { key: 15, value: "15" },
    { key: 16, value: "16" },
];

/// <summary>
/// Gets the dali times multiplier for DaliSettings 4 DIM.
/// </summary>
/// <value>
/// The switch on fade times multiplier.
/// </value>
export const daliFadeTimeMultiplier = [
    { key: 0, value: "0" },
    { key: 1, value: "0.1" },
    { key: 2, value: "1" },
    { key: 3, value: "10" },
    { key: 4, value: "60" },
];

/// <summary>
/// Gets the dali fade rate for DaliSettings 4 DIM.
/// </summary>
/// <value>
/// The switch on fade times.
/// </value>
export const daliFadeRates = [
    { key: 15, value: "2.8" },
    { key: 14, value: "4.0" },
    { key: 13, value: "5.6" },
    { key: 12, value: "7.9" },
    { key: 11, value: "11.2" },
    { key: 10, value: "15.8" },
    { key: 9, value: "22.4" },
    { key: 8, value: "31.6" },
    { key: 7, value: "44.7" },
    { key: 6, value: "63.3" },
    { key: 5, value: "89.4" },
    { key: 4, value: "127" },
    { key: 3, value: "179" },
    { key: 2, value: "253" },
    { key: 1, value: "358" },
    // { key: 0, value: "%" },
];

/// <summary>
/// Gets the switch on fade times for StepDIM 4 DIM feature.
/// </summary>
/// <value>
/// The switch on fade times.
/// </value>
export const switchOnFadeTimes = [
    { key: 0, value: "00:00" },
    { key: 15, value: "00:15" },
    { key: 30, value: "00:30" },
    { key: 45, value: "00:45" },
    { key: 60, value: "01:00" },
    { key: 120, value: "02:00" },
    { key: 300, value: "05:00" },
    { key: 600, value: "10:00" },
    { key: 900, value: "15:00" },
    { key: 1200, value: "20:00" },
    { key: 1500, value: "25:00" },
    { key: 1800, value: "30:00" },
    { key: 2100, value: "35:00" },
    { key: 2400, value: "40:00" },
    { key: 2700, value: "45:00" },
    { key: 3600, value: "60:00" },
];

/// <summary>
/// Gets the time of fade times for StepDIM 4 DIM feature.
/// </summary>
/// <value>
/// The time of fade times.
/// </value>
export const fadeTimeRangeValues = [
    { key: 0, value: "00:00" },
    { key: 2, value: "00:02" },
    { key: 4, value: "00:04" },
    { key: 6, value: "00:06" },
    { key: 8, value: "00:08" },
    { key: 10, value: "00:10" },
    { key: 20, value: "00:20" },
    { key: 30, value: "00:30" },
    { key: 40, value: "00:40" },
    { key: 50, value: "00:50" },
    { key: 60, value: "01:00" },
    { key: 120, value: "02:00" },
    { key: 180, value: "03:00" },
    { key: 240, value: "04:00" },
    { key: 300, value: "05:00" },
    { key: 360, value: "06:00" },
    { key: 480, value: "08:00" },
];

/// <summary>
/// Astro DIM fade time values.
/// </summary>
/// <returns>List of Astro DIM fade time values.</returns>
export const astroDimRangeValues = [

    //0s , 2s, 4s, 6s, 8s, 10s, 20s, 30s, 45s, 1min, 2min, 3min, 4min, 5min, 6min, 8min, Off

    { key: 0, value: "00:00" },
    { key: 2, value: "00:02" },
    { key: 4, value: "00:04" },
    { key: 6, value: "00:06" },
    { key: 8, value: "00:08" },
    { key: 10, value: "00:10" },
    { key: 20, value: "00:20" },
    { key: 30, value: "00:30" },
    { key: 40, value: "00:40" },
    { key: 50, value: "00:50" },
    { key: 60, value: "01:00" },
    { key: 120, value: "02:00" },
    { key: 180, value: "03:00" },
    { key: 240, value: "04:00" },
    { key: 300, value: "05:00" },
    { key: 360, value: "06:00" },
    { key: 480, value: "08:00" },

];

/// <summary>
/// Switch Off Fade Time Range Values for AstroDIM.
/// </summary>
/// <returns>List of Switch Off Fade Time Range Values.</returns>
export const astroDimSwitchOffRangeValues = [

    //0s (0x00 1)), 15s, 30s, 45s, 1min, 2min, 5min, 10min, 15min, 20min, 25min, 30min, 35min, 40min, 45min, 60min, Off
    //Not effect on communication as communication based on value
    { key: 255, value: "OFF" },
    { key: 0, value: "00:00" },
    { key: 15, value: "00:15" },
    { key: 30, value: "00:30" },
    { key: 45, value: "00:45" },
    { key: 60, value: "01:00" },
    { key: 120, value: "02:00" },
    { key: 300, value: "05:00" },
    { key: 600, value: "10:00" },
    { key: 900, value: "15:00" },
    { key: 1200, value: "20:00" },
    { key: 1500, value: "25:00" },
    { key: 1800, value: "30:00" },
    { key: 2100, value: "35:00" },
    { key: 2400, value: "40:00" },
    { key: 2700, value: "45:00" },
    { key: 3600, value: "60:00" },

];

/// <summary>
/// Switch On Fade Time Range Values for Astro DIM.
/// </summary>
/// <returns>List of Switch Off Fade Time Range Values.</returns>
export const astroDimSwitchOnRangeValues = [

    //0s (0x00 1)), 15s, 30s, 45s, 1min, 2min, 5min, 10min, 15min, 20min, 25min, 30min, 35min, 40min, 45min, 60min, Off
    { key: 0, value: "00:00" },
    { key: 15, value: "00:15" },
    { key: 30, value: "00:30" },
    { key: 45, value: "00:45" },
    { key: 60, value: "01:00" },
    { key: 120, value: "02:00" },
    { key: 300, value: "05:00" },
    { key: 600, value: "10:00" },
    { key: 900, value: "15:00" },
    { key: 1200, value: "20:00" },
    { key: 1500, value: "25:00" },
    { key: 1800, value: "30:00" },
    { key: 2100, value: "35:00" },
    { key: 2400, value: "40:00" },
    { key: 2700, value: "45:00" },
    { key: 3600, value: "60:00" },

];

export const currentSettingModes = [
    { key: 0, value: "LEDSet" },
    { key: 1, value: "FixedCurrent" }
];

export const luminaireInfosTypes = [
    { key: 0, value: "Type 0" },
    { key: 1, value: "Type 1" },
    { key: 2, value: "Type 2" },
    { key: 3, value: "Type 3" },
    { key: 4, value: "Type 4" },
    { key: 5, value: "Type 5" },
    { key: -1, value: "None" }
];

export const touchDimFadeTime = [
    { key: 0, value: "00:00.000" },
    { key: 1, value: "00:00.700" },
    { key: 2, value: "00:01.000" },
    { key: 3, value: "00:01.400" },
    { key: 4, value: "00:02.000" },
    { key: 5, value: "00:02.800" },
    { key: 6, value: "00:04.000" },
    { key: 7, value: "00:05.700" },
    { key: 8, value: "00:08.000" },
    { key: 9, value: "00:11.300" },
    { key: 10, value: "00:16.000" },
    { key: 11, value: "00:22.600" },
    { key: 12, value: "00:32.000" },
    { key: 13, value: "00:45.300" },
    { key: 14, value: "01:04.000" },
    { key: 15, value: "01:30.500" }
];

export const touchDimFadeTime2 = [
    { key: 0, value: "00:00.000" },
    { key: 1, value: "00:00.100" },
    { key: 2, value: "00:00.200" },
    { key: 3, value: "00:00.300" },
    { key: 4, value: "00:00.400" },
    { key: 5, value: "00:00.500" },
    { key: 6, value: "00:00.600" },
    { key: 7, value: "00:00.700" },
    { key: 8, value: "00:00.800" },
    { key: 9, value: "00:00.900" },
    { key: 10, value: "00:01.000" },
    { key: 11, value: "00:01.100" },
    { key: 12, value: "00:01.200" },
    { key: 13, value: "00:01.300" },
    { key: 14, value: "00:01.400" },
    { key: 15, value: "00:01.500" },
    { key: 16, value: "00:01.600" },
    { key: 17, value: "00:02.000" },
    { key: 18, value: "00:02.800" },
    { key: 19, value: "00:04.000" },
    { key: 20, value: "00:05.700" },
    { key: 21, value: "00:08.000" },
    { key: 22, value: "00:11.300" },
    { key: 23, value: "00:16.000" },
    { key: 24, value: "00:22.600" },
    { key: 25, value: "00:32.000" },
    { key: 26, value: "00:45.300" },
    { key: 27, value: "01:04.000" },
    { key: 28, value: "01:30.500" }
];

export const touchDimHoldTime = [
    { key: 0, value: "00:00:05" },
    { key: 1, value: "00:00:10" },
    { key: 2, value: "00:00:15" },
    { key: 3, value: "00:00:20" },
    { key: 4, value: "00:00:25" },
    { key: 5, value: "00:00:30" },
    { key: 6, value: "00:00:35" },
    { key: 7, value: "00:00:40" },
    { key: 8, value: "00:00:46" },
    { key: 9, value: "00:00:51" },
    { key: 10, value: "00:00:56" },
    { key: 11, value: "00:01:01" },
    { key: 12, value: "00:01:06" },
    { key: 13, value: "00:01:11" },
    { key: 14, value: "00:01:16" },
    { key: 15, value: "00:01:21" },
    { key: 16, value: "00:01:27" },
    { key: 17, value: "00:01:32" },
    { key: 18, value: "00:01:37" },
    { key: 19, value: "00:01:42" },
    { key: 20, value: "00:01:47" },
    { key: 21, value: "00:01:57" },
    { key: 22, value: "00:02:02" },
    { key: 23, value: "00:02:07" },
    { key: 24, value: "00:02:13" },
    { key: 25, value: "00:02:18" },
    { key: 26, value: "00:02:23" },
    { key: 27, value: "00:02:28" },
    { key: 28, value: "00:02:33" },
    { key: 29, value: "00:02:38" },
    { key: 30, value: "00:02:43" },
    { key: 31, value: "00:02:48" },
    { key: 32, value: "00:02:54" },
    { key: 33, value: "00:02:59" },
    { key: 34, value: "00:03:04" },
    { key: 35, value: "00:03:09" },
    { key: 36, value: "00:03:14" },
    { key: 37, value: "00:03:19" },
    { key: 38, value: "00:03:24" },
    { key: 39, value: "00:03:29" },
    { key: 40, value: "00:03:35" },
    { key: 41, value: "00:03:40" },
    { key: 42, value: "00:03:45" },
    { key: 43, value: "00:03:50" },
    { key: 44, value: "00:03:55" },
    { key: 45, value: "00:04:00" },
    { key: 46, value: "00:04:05" },
    { key: 47, value: "00:04:10" },
    { key: 48, value: "00:04:15" },
    { key: 49, value: "00:04:20" },
    { key: 50, value: "00:04:26" },
    { key: 51, value: "00:04:31" },
    { key: 52, value: "00:04:36" },
    { key: 53, value: "00:04:41" },
    { key: 54, value: "00:04:46" },
    { key: 55, value: "00:04:51" },
    { key: 56, value: "00:04:56" },
    { key: 57, value: "00:05:02" },
    { key: 58, value: "00:05:07" },
    { key: 59, value: "00:05:12" },
    { key: 60, value: "00:05:17" },
    { key: 61, value: "00:05:22" },
    { key: 62, value: "00:05:27" },
    { key: 63, value: "00:05:32" },
    { key: 64, value: "00:05:37" },
    { key: 65, value: "00:05:43" },
    { key: 66, value: "00:05:48" },
    { key: 67, value: "00:05:53" },
    { key: 68, value: "00:05:58" },
    { key: 69, value: "00:06:03" },
    { key: 70, value: "00:06:08" },
    { key: 71, value: "00:06:13" },
    { key: 72, value: "00:06:18" },
    { key: 73, value: "00:06:23" },
    { key: 74, value: "00:06:29" },
    { key: 75, value: "00:06:34" },
    { key: 76, value: "00:06:39" },
    { key: 77, value: "00:06:44" },
    { key: 78, value: "00:06:49" },
    { key: 79, value: "00:06:54" },
    { key: 80, value: "00:06:59" },
    { key: 81, value: "00:07:04" },
    { key: 82, value: "00:07:10" },
    { key: 83, value: "00:07:15" },
    { key: 84, value: "00:07:20" },
    { key: 85, value: "00:07:25" },
    { key: 86, value: "00:07:30" },
    { key: 87, value: "00:07:35" },
    { key: 88, value: "00:07:40" },
    { key: 89, value: "00:07:45" },
    { key: 90, value: "00:07:51" },
    { key: 91, value: "00:07:56" },
    { key: 92, value: "00:08:01" },
    { key: 93, value: "00:08:06" },
    { key: 94, value: "00:08:11" },
    { key: 95, value: "00:08:16" },
    { key: 96, value: "00:08:21" },
    { key: 97, value: "00:08:26" },
    { key: 98, value: "00:08:31" },
    { key: 99, value: "00:08:37" },
    { key: 100, value: "00:08:42" },
    { key: 101, value: "00:08:47" },
    { key: 102, value: "00:08:52" },
    { key: 103, value: "00:08:57" },
    { key: 104, value: "00:09:02" },
    { key: 105, value: "00:09:07" },
    { key: 106, value: "00:09:12" },
    { key: 107, value: "00:09:18" },
    { key: 108, value: "00:09:23" },
    { key: 109, value: "00:09:28" },
    { key: 110, value: "00:09:33" },
    { key: 111, value: "00:09:38" },
    { key: 112, value: "00:09:43" },
    { key: 113, value: "00:09:48" },
    { key: 114, value: "00:09:53" },
    { key: 115, value: "00:09:59" },
    { key: 116, value: "00:10:04" },
    { key: 117, value: "00:10:09" },
    { key: 118, value: "00:10:14" },
    { key: 119, value: "00:10:19" },
    { key: 120, value: "00:10:24" },
    { key: 121, value: "00:10:29" },
    { key: 122, value: "00:10:34" },
    { key: 123, value: "00:10:39" },
    { key: 124, value: "00:10:45" },
    { key: 125, value: "00:10:50" },
    { key: 126, value: "00:10:55" },
    { key: 127, value: "00:11:00" },
    { key: 128, value: "00:11:05" },
    { key: 129, value: "00:11:10" },
    { key: 130, value: "00:11:15" },
    { key: 131, value: "00:11:20" },
    { key: 132, value: "00:11:26" },
    { key: 133, value: "00:11:31" },
    { key: 134, value: "00:11:36" },
    { key: 135, value: "00:11:41" },
    { key: 136, value: "00:11:46" },
    { key: 137, value: "00:11:51" },
    { key: 138, value: "00:11:56" },
    { key: 139, value: "00:12:01" },
    { key: 140, value: "00:12:07" },
    { key: 141, value: "00:12:12" },
    { key: 142, value: "00:12:17" },
    { key: 143, value: "00:12:22" },
    { key: 144, value: "00:12:27" },
    { key: 145, value: "00:12:32" },
    { key: 146, value: "00:12:37" },
    { key: 147, value: "00:12:42" },
    { key: 148, value: "00:12:47" },
    { key: 149, value: "00:12:53" },
    { key: 150, value: "00:12:58" },
    { key: 151, value: "00:13:03" },
    { key: 152, value: "00:13:08" },
    { key: 153, value: "00:13:13" },
    { key: 154, value: "00:13:18" },
    { key: 155, value: "00:13:23" },
    { key: 156, value: "00:13:28" },
    { key: 157, value: "00:13:34" },
    { key: 158, value: "00:13:39" },
    { key: 159, value: "00:13:44" },
    { key: 160, value: "00:13:49" },
    { key: 161, value: "00:13:54" },
    { key: 162, value: "00:13:59" },
    { key: 163, value: "00:14:04" },
    { key: 164, value: "00:14:09" },
    { key: 165, value: "00:14:15" },
    { key: 166, value: "00:14:20" },
    { key: 167, value: "00:14:25" },
    { key: 168, value: "00:14:30" },
    { key: 169, value: "00:14:35" },
    { key: 170, value: "00:14:40" },
    { key: 171, value: "00:14:45" },
    { key: 172, value: "00:14:50" },
    { key: 173, value: "00:14:55" },
    { key: 174, value: "00:15:01" },
    { key: 175, value: "00:15:06" },
    { key: 176, value: "00:15:11" },
    { key: 177, value: "00:15:16" },
    { key: 178, value: "00:15:21" },
    { key: 179, value: "00:15:26" },
    { key: 180, value: "00:15:31" },
    { key: 181, value: "00:15:36" },
    { key: 182, value: "00:15:42" },
    { key: 183, value: "00:15:47" },
    { key: 184, value: "00:15:52" },
    { key: 185, value: "00:15:57" },
    { key: 186, value: "00:16:02" },
    { key: 187, value: "00:16:07" },
    { key: 188, value: "00:16:12" },
    { key: 189, value: "00:16:17" },
    { key: 190, value: "00:16:23" },
    { key: 191, value: "00:16:28" },
    { key: 192, value: "00:16:33" },
    { key: 193, value: "00:16:38" },
    { key: 194, value: "00:16:43" },
    { key: 195, value: "00:16:48" },
    { key: 196, value: "00:16:53" },
    { key: 197, value: "00:16:58" },
    { key: 198, value: "00:17:03" },
    { key: 199, value: "00:17:09" },
    { key: 200, value: "00:17:14" },
    { key: 201, value: "00:17:19" },
    { key: 202, value: "00:17:24" },
    { key: 203, value: "00:17:29" },
    { key: 204, value: "00:17:34" },
    { key: 205, value: "00:17:39" },
    { key: 206, value: "00:17:44" },
    { key: 207, value: "00:17:50" },
    { key: 208, value: "00:17:50" },
    { key: 209, value: "00:18:00" },
    { key: 210, value: "00:18:05" },
    { key: 211, value: "00:18:10" },
    { key: 212, value: "00:18:15" },
    { key: 213, value: "00:18:20" },
    { key: 214, value: "00:18:25" },
    { key: 215, value: "00:18:31" },
    { key: 216, value: "00:18:36" },
    { key: 217, value: "00:18:41" },
    { key: 218, value: "00:18:46" },
    { key: 219, value: "00:18:51" },
    { key: 220, value: "00:18:56" },
    { key: 221, value: "00:19:01" },
    { key: 222, value: "00:19:06" },
    { key: 223, value: "00:19:11" },
    { key: 224, value: "00:19:17" },
    { key: 225, value: "00:19:22" },
    { key: 226, value: "00:19:27" },
    { key: 227, value: "00:19:32" },
    { key: 228, value: "00:19:37" },
    { key: 229, value: "00:19:42" },
    { key: 230, value: "00:19:47" },
    { key: 231, value: "00:19:52" },
    { key: 232, value: "00:19:58" },
    { key: 233, value: "00:20:03" },
    { key: 234, value: "00:20:09" },
    { key: 235, value: "00:20:13" },
    { key: 236, value: "00:20:18" },
    { key: 237, value: "00:20:23" },
    { key: 238, value: "00:20:28" },
    { key: 239, value: "00:20:33" },
    { key: 240, value: "00:20:39" },
    { key: 241, value: "00:20:44" },
    { key: 242, value: "00:20:49" },
    { key: 243, value: "00:20:54" },
    { key: 244, value: "00:20:59" },
    { key: 245, value: "00:21:04" },
    { key: 246, value: "00:21:09" },
    { key: 247, value: "00:21:14" },
    { key: 248, value: "00:21:19" },
    { key: 249, value: "00:21:25" },
    { key: 250, value: "00:21:30" },
    { key: 251, value: "00:21:35" },
    { key: 252, value: "00:21:40" },
    { key: 253, value: "00:21:45" },
    { key: 254, value: "Infinite" }
];

export const dimmingModes = [
    { key: 0, value: "Analog Dimming" },
    { key: 1, value: "Hybrid Dimming" }
];

/// <summary>
/// Astro dim fade time list calculation.
/// </summary>
/// <param name="devicedescriptionFileValue">The device description file value.</param>
/// <returns>Returns the list of astro dim fade time value.</returns>
export function astroDimFadeTime(devicedescriptionFileValue) {
    let returnValue = [];
    if (devicedescriptionFileValue != null) {
        devicedescriptionFileValue.forEach(devicedescription => {
            returnValue.push({ key: devicedescription.key, value: getTime(devicedescription.value) });
        });
    }

    return returnValue;
}

/// <summary>
/// Gets the time in the minutes:seconds format for astroDIM.
/// </summary>
/// <param name="value">The value.</param>
/// <returns>Returns in date time for the given value.</returns>
function getTime(value) {
    var date = new Date(null);
    date.setSeconds(value); // specify value for SECONDS here
    return date.toISOString().substr(14, 5);
}

export function getHours(value) {
    var date = new Date(null);
    date.setMilliseconds(value * 1000); // specify value for SECONDS here

    if (value === 'X') {
        //In T4T-Develop is like that
        return "OFF";
    }
    else {
        return date.toISOString().substr(14, 9);
    }
}

export function getHoursTD(value) {

    if (value !== 'Infinite') {
        var date = new Date(null);
        date.setSeconds(value);
        return date.toISOString().substr(11, 8);
    }
    else {
        return value;
    }
}

export function getHoursTD60Hz(value) {

    if (value !== 'Infinite') {
        var date = new Date(null);
        date.setSeconds(Math.round(value / 6 * 5));
        return date.toISOString().substr(11, 8);
    }
    else {
        return value;
    }
}

export function getHoursCD(value) {

    switch (value) {
        case '0':
            return 'OFF';
        case 'Infinite':
            return value;
        default:
            var date = new Date(null);
            date.setSeconds(value);
            return date.toISOString().substr(11, 8);
    }
}

export function getHoursCD60Hz(value) {

    switch (value) {
        case '0':
            return 'OFF';
        case 'Infinite':
            return value;
        default:
            var date = new Date(null);
            date.setSeconds(Math.round(value / 6 * 5));
            return date.toISOString().substr(11, 8);
    }
}

export function getTouchDimFadeTime(value) {
    var date = new Date(null);

    if (value !== 'Infinite') {
        date.setMinutes(value);
        return date.toISOString().substr(11, 8);
    }
    else {
        return value;
    }
}

export function getMinutes(value) {
    var date = new Date(null);
    date.setSeconds(value);

    switch (value) {
        case "3600":
            //In T4T-Develop is like that
            return "60:00";
        case "OFF":
        case "Off":
        case "off":
            return value;
        default:
            return date.toISOString().substr(14, 5);
    };
}

export function getMinutesChart(value) {
    var date = new Date(null);
    date.setSeconds(value);

    switch (value) {
        case "3600":
            //In T4T-Develop is like that
            return "60";
        case "OFF":
        case "Off":
        case "off":
            return "00";
        default:
            return date.toISOString().substr(14, 2);
    };
}
